import React from 'react';
import PropTypes from 'prop-types';

/**
 * An <img> that defers loading until it approaches the viewport.
 *
 * Only use this for images that are reliably BELOW THE FOLD (below-the-fold
 * wrappers, content sections, overlays). Never use it for the hero, the logo,
 * the portal bar or anything else painted in the initial viewport - lazy
 * loading the LCP element makes the page measurably slower.
 *
 * `decoding="async"` keeps image decoding off the main thread, which helps TBT.
 *
 * `alt` is deliberately NOT defaulted here: an empty alt marks an image as
 * decorative and changes its ARIA role from `img` to `presentation`. Callers
 * decide, exactly as they did with a plain <img>.
 *
 * Props are spread last so a caller can still override `loading` for an edge case.
 */
function LazyImage({ src, ...rest }) {
	return (
		<img
			src={src}
			loading="lazy"
			decoding="async"
			{...rest}
		/>
	);
}

export default LazyImage;

LazyImage.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
};
